import { shefSpiceText, SpiceLevel } from 'common/SpiceLevels';
import React, { useMemo } from 'react';
import hotSpiceTag from 'src/assets/svg/order/dietary-spicy-hot.svg';
import mediumSpiceTag from 'src/assets/svg/order/dietary-spicy-medium.svg';
import mildSpiceTag from 'src/assets/svg/order/dietary-spicy-mild.svg';
import noneSpiceTag from 'src/assets/svg/order/dietary-spicy-none.svg';
import styled from 'styled-components';
import { match } from 'ts-pattern';
import { Spacing } from 'web-common/src/shared/styles';

interface IProps {
  spiceLevel: SpiceLevel | number;
  displaySpiceText?: boolean;
  imageSize?: string;
}

export const SpiceImage = styled.img<{ showSmallIcon?: boolean; size?: string }>`
  height: ${(props) => (props.size ? props.size : '16px')};
`;
export const SpiceText = styled.span`
  margin-left: ${Spacing.HALF};
`;

export const generateSpiceTagProps = (spiceLevel: SpiceLevel | number) =>
  match<SpiceLevel | number>(spiceLevel)
    .with(SpiceLevel.SPICY, SpiceLevel.MILD, (sLevel) => {
      const spiceText = shefSpiceText.get(sLevel);

      return {
        spiceLevel: sLevel,
        title: 'Mild Spice Level',
        alt: 'Mild Spice Level',
        src: mildSpiceTag,
        'data-cy': 'Mild Spice Icon',
        spiceText,
      };
    })
    .with(SpiceLevel.MEDIUM, (sLevel) => {
      const spiceText = shefSpiceText.get(sLevel);

      return {
        spiceLevel: sLevel,
        title: 'Medium Spice Level',
        alt: 'Medium Spice Level',
        src: mediumSpiceTag,
        'data-cy': 'Medium Spice Level',
        spiceText,
      };
    })
    .with(SpiceLevel.HOT, (sLevel) => {
      const spiceText = shefSpiceText.get(sLevel);

      return {
        spiceLevel: sLevel,
        title: 'Hot Spice Level',
        alt: 'Hot Spice Level',
        src: hotSpiceTag,
        'data-cy': 'Hot Spice Level',
        spiceText,
      };
    })
    .otherwise(() => ({
      spiceLevel: SpiceLevel.NOT_SPICY,
      title: 'None Spice Level',
      alt: 'None Spice Level',
      src: noneSpiceTag,
      'data-cy': 'None Spice Level',
      spiceText: 'Not Spicy',
    }));

export const SpiceTag: React.FC<IProps> = (props) => {
  const { spiceLevel, displaySpiceText = false, imageSize } = props;

  const spiceImageData = useMemo(() => generateSpiceTagProps(spiceLevel), [spiceLevel]);

  const { spiceText, ...imageProps } = spiceImageData;

  return (
    <>
      <SpiceImage {...imageProps} showSmallIcon={displaySpiceText} size={imageSize} />
      {displaySpiceText && <SpiceText>{spiceText}</SpiceText>}
    </>
  );
};
